import dayjs, { type Dayjs } from 'dayjs';

import type { Interval } from '../../TimelineView/types';

/**
 * Clamp a block (absence/availability) to the visible interval so it never
 * renders outside the timeline window.
 */
export const clampToInterval = (
  rawStart: string,
  rawEnd: string,
  interval: Interval
): {
  start: Dayjs;
  end: Dayjs;
  startsDayBefore: boolean;
  endsDayAfter: boolean;
  durationInSeconds: number;
} => {
  const startsDayBefore = dayjs(rawStart).isBefore(dayjs(interval.start));
  const endsDayAfter = dayjs(rawEnd).isAfter(dayjs(interval.end));
  const start = startsDayBefore ? dayjs(interval.start) : dayjs(rawStart);
  const end = endsDayAfter ? dayjs(interval.end) : dayjs(rawEnd);
  return {
    start,
    end,
    startsDayBefore,
    endsDayAfter,
    durationInSeconds: end.diff(start, 'seconds')
  };
};

/** Absence label times: spill-over days show the full date, otherwise just HH:mm. */
export const getAbsenceLabelTimes = (
  rawStart: string,
  rawEnd: string,
  startsDayBefore: boolean,
  endsDayAfter: boolean
): { startString: string; endString: string } => ({
  startString: startsDayBefore
    ? dayjs(rawStart).format('D MMMM YYYY HH:mm')
    : dayjs(rawStart).format('HH:mm'),
  endString: endsDayAfter
    ? dayjs(rawEnd).format('D MMMM YYYY HH:mm')
    : dayjs(rawEnd).format('HH:mm')
});
